import React, { useState, useEffect } from 'react';
import { postCertificadosEspecificos_f, postCertificadosEspecificos_j } from '../../services/AuthService'; // Ajuste no caminho do import
import styles from './consult.module.css';
import Masonry from 'react-masonry-css'

function Step4CertificadoEspecifico({estado, tipoPessoa, onComplete, onBack }) {
    const [certificados, setCertificados] = useState({});
    const [selectedCertidoes, setSelectedCertidoes] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        setLoading(true);
        setError('');

        const request =
            tipoPessoa === 'Físico'
            ? postCertificadosEspecificos_f(estado)
            : postCertificadosEspecificos_j(estado);

        request
            .then(data => {
                setCertificados(data);
                setLoading(false);
            })
            .catch(err => {
                setError('Falha ao carregar certificados específicos: ' + (err?.message || err));
                setLoading(false);
            });
    }, [estado, tipoPessoa]);

    const getSelectedCertidoes = () => {
        const selectedCertidoesArray = [];
    
        Object.keys(selectedCertidoes).forEach(nivel => {
            Object.keys(selectedCertidoes[nivel]).forEach(site => {
                Object.keys(selectedCertidoes[nivel][site]).forEach(tipoCertidao => {
                    // Verifica se `selectedCertidoes[nivel][site][tipoCertidao]` é um array
                    if (Array.isArray(selectedCertidoes[nivel][site][tipoCertidao])) {
                        selectedCertidoes[nivel][site][tipoCertidao].forEach(certidao => {
                            selectedCertidoesArray.push({
                                certidao_id: certidao.certidao_id,
                                estado: certidao.estado 
                            });
                        });
                    }
                });
            });
        });
    
        return selectedCertidoesArray;
    };

    // Marcar/Desmarcar todas as certidões
    const toggleAllCertidoes = (markAll) => {
        const newSelection = {};
        Object.keys(certificados).forEach(nivel => {
            newSelection[nivel] = {};
            Object.keys(certificados[nivel]).forEach(site => {
                newSelection[nivel][site] = {};
                Object.keys(certificados[nivel][site]).forEach(tipoCertidao => {
                    // Verifica se certificados[nivel][site][tipoCertidao] é um array antes de iterar
                    if (Array.isArray(certificados[nivel][site][tipoCertidao])) {
                        newSelection[nivel][site][tipoCertidao] = markAll ? [...certificados[nivel][site][tipoCertidao]] : [];
                    } else {
                        newSelection[nivel][site][tipoCertidao] = []; // Define como vazio se não for array
                    }
                });
            });
        });
        setSelectedCertidoes(newSelection);
    };

    // Marcar/Desmarcar todas as certidões de um site
    const toggleSiteCertidoes = (site, markAll) => {
        const newSelection = { ...selectedCertidoes };
        newSelection[site] = {};
        Object.keys(certificados[site]).forEach(tipoCertidao => {
            newSelection[site][tipoCertidao] = markAll ? [...certificados[site][tipoCertidao]] : [];
        });
        setSelectedCertidoes(newSelection);
    };

    // Marcar/Desmarcar todas as certidões de um tipo
    const toggleTipoCertidao = (site, tipoCertidao, markAll) => {
        const newSelection = { ...selectedCertidoes };
        newSelection[site] = newSelection[site] || {};
        newSelection[site][tipoCertidao] = markAll ? [...certificados[site][tipoCertidao]] : [];
        setSelectedCertidoes(newSelection);
    };

    // Marcar/Desmarcar uma certidão específica
    const toggleCertidao = (nivel, site, tipoCertidao, certidao) => {
        const newSelection = { ...selectedCertidoes };
        newSelection[nivel] = newSelection[nivel] || {};
        newSelection[nivel][site] = newSelection[nivel][site] || {};
        newSelection[nivel][site][tipoCertidao] = newSelection[nivel][site][tipoCertidao] || [];
    
        const certidaoIndex = newSelection[nivel][site][tipoCertidao].findIndex(c => c.certidao_id === certidao.certidao_id);
        if (certidaoIndex === -1) {
            newSelection[nivel][site][tipoCertidao].push(certidao); // Seleciona a certidão
        } else {
            newSelection[nivel][site][tipoCertidao].splice(certidaoIndex, 1); // Desmarca a certidão
        }
        setSelectedCertidoes(newSelection);
    };

    if (loading) return <div>Carregando...</div>;
    if (error) return <div>{error}</div>;

    const breakpointCols = {
    default: 3,  // acima de 1200px -> 3 colunas
    900:     2,  // entre 900px e 1200px -> 2 colunas
    600:     1   // abaixo de 600px -> 1 coluna
    }

    return (
        <div className={`${styles.step4Container} ${styles.consultPage}`}>
            <h4>Escolha o Certificado Específico</h4>

            <div className={styles.buttonsContainer}>
                <button onClick={() => toggleAllCertidoes(true)}>Marcar todas</button>
                <button onClick={() => toggleAllCertidoes(false)}>Desmarcar todas</button>
            </div>

            <Masonry breakpointCols={breakpointCols} className={styles.masonryGrid}  columnClassName={styles.masonryCol}>
                {Object.keys(certificados).map(nivel => (
                    <div key={nivel} className={styles.nivelColumn}>
                        <h2 className={styles.nivelTitle}>{nivel}</h2>
                        {Object.keys(certificados[nivel]).map(site => (
                            <div key={site} className={styles.siteContainer}>
                                <h3 className={styles.siteTitle}>Site: {site}</h3>
                                {Object.keys(certificados[nivel][site]).map(tipoCertidao => (
                                    <div key={tipoCertidao} className={styles.certidaoContainer}>
                                        <h4 className={styles.certidaoTitle}>Tipo de Certidão: {tipoCertidao}</h4>
                                        <div className={styles.certidoesList}>
                                            {certificados[nivel][site][tipoCertidao].map(certidao => (
                                                <div key={certidao.certidao_id} className={styles.certidaoItem}>
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            selectedCertidoes[nivel]?.[site]?.[tipoCertidao]?.some(
                                                                c => c.certidao_id === certidao.certidao_id
                                                            ) || false
                                                        }
                                                        onChange={() => toggleCertidao(nivel, site, tipoCertidao, certidao)}
                                                    />
                                                    <label className={styles.certidaoLabel}>
                                                        {certidao.nome_certidao}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                ))}
            </Masonry>

            <div className={styles.buttonsContainer}>
                <button onClick={() => onComplete(getSelectedCertidoes())}>Confirmar seleção</button>
                <button className={styles.backButton} onClick={onBack} >Voltar</button>
            </div>
        </div>
    );
}

export default Step4CertificadoEspecifico;
